/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { NetworkFilterSchemaMinStrength } from './networkFilterSchemaMinStrength';
import type { NetworkFilterSchemaMode } from './networkFilterSchemaMode';
import type { NetworkFilterSchemaSourcesItem } from './networkFilterSchemaSourcesItem';

/**
 * People the team has a path to (``app.services.network``).
 *
 * ``mode`` ``include`` keeps only those people; ``exclude`` leaves them out
 * (net-new sourcing). ``member_ids`` are network member ids (Arbi users and
 * external members); empty = every active network member.
 * ``min_strength`` applies to overlaps; connections always count.
 */
export interface NetworkFilterSchema {
  mode?: NetworkFilterSchemaMode;
  /**
     * @minItems 1
     * @maxItems 2
     */
  sources?: NetworkFilterSchemaSourcesItem[];
  /** @maxItems 50 */
  member_ids?: string[];
  min_strength?: NetworkFilterSchemaMinStrength;
}
